import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';

// It can parse html:
// <table id="my-table"><!-- ... --></table>
export function exportPdfTable(cfg = { selector: '#my-table', fileName: 'table.pdf' }) {
  const doc = new jsPDF();

  autoTable(doc, { html: cfg.selector });
  doc.save(cfg.fileName);
}

// Or use javascript directly:
export function exportPdf(data = { title: 'Report', head: [], body: [], fileName: 'report.pdf' }) {
  const doc = new jsPDF({
    orientation: 'landscape'
  });

  doc.setFontSize(13);
  doc.text(data.title, 15, 10);
  doc.setFontSize(8);
  doc.text(moment().format('DD/MM/YYYY HH:mm'), 260, 10);

  autoTable(doc, {
    styles: {
      cellWidth: 'auto',
      halign: 'center',
      minCellWidth: 20
    },
    head: [data.head],
    body: data.body
  });

  doc.save(data.fileName);
}
